import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate, useParams } from "react-router-dom"
import ReactQuill from "react-quill"
import { isEmpty } from "lodash"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import "react-quill/dist/quill.snow.css"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DeleteModal from "../../../components/Common/DeleteModal"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import {
  getOrders as onGetOrders,
  addNewOrder as onAddNewOrder,
  updateOrder as onUpdateOrder,
  deleteOrder as onDeleteOrder,
} from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import EcommerceOrdersModal from "./EcommerceOrdersModal"
import { Button, Col, Row, Input } from "reactstrap"
import { ToastContainer } from "react-toastify"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
let questionNo = 0
export const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [' rgb(156 195 25)','rgb(227 104 29)'] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["clean"], // remove formatting button
]

function CMSDetails() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [cmsData, setCMSData] = useState()
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [registrationData, setRegistrationData] = useState({})
  //meta title
  document.title = "Inventya"
  const getCMSDetails = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.getCMSDetails(id)
      setCMSData(data)
      data && setTitle(data?.title)
      data && setDescription(data?.description)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }
  const handleSubmission = async () => {
    try {
      let params = { title: title, description: description }
      const {
        data: { data },
      } = await API_SERVICE.editCMS(id, params)
      notification("success", "Edited")
      navigate(-1)
    } catch (error) {
      notification("error", error.response.statusText)
    }
  }
  useEffect(() => {
    questionNo = 0
    getCMSDetails()
  }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">CMS-{cmsData?.name}</h4>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="10" className="my-3">
              <h4 className=" font-size-18 my-2">TITLE</h4>
              <Input
                type="textarea"
                rows={3}
                value={title}
                onChange={event => setTitle(event.target.value)}
                name="projectdesc"
                placeholder="Enter Project Description..."
              />
            </Col>
            <Col lg="10" className="my-3">
              <h4 className="\ font-size-18 mb-2">BODY/CONTENT</h4>
              <ReactQuill
                placeholder={`${"Write your answer here..."}`}
                modules={{
                  toolbar: toolbarOptions,
                }}
                style={{ backgroundColor: "white" }}
                theme="snow"
                value={description}
                onChange={value => {
                  console.log(value)
                  setDescription(value)
                }}
              />
            </Col>
            <Col lg="10">
              <div
                className="text-end d-flex justify-content-end align-items-center gap-3"
                //   onClick={toggleActive}
              >
                <button
                  className="btn theme-btn-outline save-user mr-2"
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </button>
                <button
                  type="submit"
                  className="btn theme-btn save-user"
                  onClick={handleSubmission}
                >
                  Save
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default CMSDetails
